"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./new-password-holder.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./new-password-holder.component");
var i3 = require("../../Services/service.service");
var i4 = require("@angular/router");
var i5 = require("@angular/material/dialog");
var styles_NewPasswordHolderComponent = [i0.styles];
var RenderType_NewPasswordHolderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_NewPasswordHolderComponent, data: {} });
exports.RenderType_NewPasswordHolderComponent = RenderType_NewPasswordHolderComponent;
function View_NewPasswordHolderComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
exports.View_NewPasswordHolderComponent_0 = View_NewPasswordHolderComponent_0;
function View_NewPasswordHolderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-new-password-holder", [], null, null, null, View_NewPasswordHolderComponent_0, RenderType_NewPasswordHolderComponent)), i1.ɵdid(1, 114688, null, 0, i2.NewPasswordHolderComponent, [i3.MainService, i4.ActivatedRoute, i5.MatDialog], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_NewPasswordHolderComponent_Host_0 = View_NewPasswordHolderComponent_Host_0;
var NewPasswordHolderComponentNgFactory = i1.ɵccf("app-new-password-holder", i2.NewPasswordHolderComponent, View_NewPasswordHolderComponent_Host_0, {}, {}, []);
exports.NewPasswordHolderComponentNgFactory = NewPasswordHolderComponentNgFactory;
